import { render, staticRenderFns } from "./GiftRecapModal.vue?vue&type=template&id=405e7887&scoped=true&"
import script from "./GiftRecapModal.vue?vue&type=script&lang=ts&"
export * from "./GiftRecapModal.vue?vue&type=script&lang=ts&"
import style0 from "./GiftRecapModal.vue?vue&type=style&index=0&id=405e7887&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405e7887",
  null
  
)

export default component.exports